import React from "react";
import ServiceTrackPage from "./ServiceTrackPage";

const knowledgeRagPhases = [
  {
    step: "01",
    title: "Knowledge Audit",
    detail:
      "We assess your documentation landscape, data quality, and context gaps that directly impact AI answer accuracy and agent reliability.",
  },
  {
    step: "02",
    title: "RAG Architecture & Data Design",
    detail:
      "We define chunking, embedding strategy, retrieval logic, and relevance controls for high-precision context delivery at production scale.",
  },
  {
    step: "03",
    title: "Pipeline Build & Fine-Tuning",
    detail:
      "We implement the full RAG pipeline, train domain-specific models where needed, and establish quality evaluation benchmarks against your tasks.",
  },
  {
    step: "04",
    title: "Governance & Scale",
    detail:
      "We add access controls, version management, auditability, and monitoring to run the knowledge system safely and accurately across teams.",
  },
];

const KnowledgeRagPage = () => {
  return (
    <ServiceTrackPage
      trackLabel="Knowledge & RAG Track"
      title="Make Your Data the Most Powerful Asset in Your AI Stack"
      accentLine="From unstructured data to actionable intelligence."
      description="Most AI systems fail not because the model is wrong — but because the data feeding it is unstructured, incomplete, or inaccessible. We build knowledge infrastructure, RAG pipelines, and fine-tuned models that give your AI systems accurate, relevant, and governed access to what your organization actually knows."
      topPrimaryCtaLabel="Book a Knowledge Session"
      topSecondaryCtaLabel="See Execution Model"
      engagementId="knowledge-rag-delivery"
      outcomesHeading="What You Walk Away With"
      outcomes={[
        "RAG pipeline with precision retrieval across your internal knowledge base",
        "Domain-specific fine-tuned models outperforming general-purpose LLMs on your tasks",
        "Multimodal document intelligence across PDFs, images, and structured data",
        "Governance controls for access, versioning, and auditability",
      ]}
      metricsHeading="Expected Outcomes"
      metrics={[
        { value: "<300ms", label: "retrieval latency target" },
        { value: "95%+", label: "retrieval precision target" },
        { value: "100%", label: "audit-ready workflows" },
        { value: "1", label: "governed knowledge backbone" },
      ]}
      phases={knowledgeRagPhases}
      finalEyebrow="Final Step"
      finalTitleLine="Your data is already there. Let's make it usable."
      finalAccentLine="Start with the right retrieval foundation."
      finalDescription="Strong knowledge infrastructure makes every agent, copilot, and AI workflow more accurate, consistent, and trustworthy — from day one and at scale."
      finalCtaLabel="Book a Free Audit"
    />
  );
};

export default KnowledgeRagPage;
